module.exports = __webpack_public_path__ + "static/media/image.d75f3d63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EmailSigs/image.jpg
// module id = 85
// module chunks = 0